export const SuccessLogo = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='108'
      height='108'
      viewBox='0 0 108 108'
      fill='none'>
      <g filter='url(#filter0_d_695_49931)'>
        <circle cx='56' cy='54' r='36' fill='url(#paint0_linear_695_49931)' />
        <circle cx='56' cy='54' r='36' fill='#FF0000' fill-opacity='0.2' />
      </g>
      <g filter='url(#filter1_bd_695_49931)'>
        <path
          d='M58.4923 76.8609L41.1422 59.583C39.6193 58.0644 39.6193 55.6021 41.1422 54.0833L46.6575 48.5835C48.1805 47.0647 50.65 47.0647 52.173 48.5835L61.25 57.6117L93.827 25.139C95.35 23.6203 97.8195 23.6203 99.3425 25.139L104.858 30.6387C106.381 32.1574 106.381 34.6197 104.858 36.1385L64.0077 76.861C62.4846 78.3797 60.0152 78.3797 58.4923 76.8609Z'
          fill='#FFD6C1'
          fill-opacity='0.6'
          shape-rendering='crispEdges'
        />
        <path
          d='M58.8451 76.5066L58.8453 76.5068C60.1732 77.831 62.3267 77.831 63.6547 76.507L63.6547 76.5069L104.505 35.7845C105.832 34.461 105.832 32.3161 104.505 30.9928L104.858 30.6387L104.505 30.9928L98.9894 25.493C97.6616 24.169 95.5079 24.169 94.1801 25.493L94.18 25.4931L61.603 57.9658L61.2504 58.3173L60.8974 57.9662L51.8204 48.938L51.8199 48.9375C50.4921 47.6133 48.3384 47.6133 47.0106 48.9375L47.0106 48.9375L41.4953 54.4373C40.1683 55.7607 40.1682 57.9054 41.4951 59.2287L58.8451 76.5066ZM58.8451 76.5066L41.4953 59.229L58.8451 76.5066Z'
          stroke='white'
          strokeOpacity='0.25'
          shape-rendering='crispEdges'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_695_49931'
          x='0'
          y='2'
          width='112'
          height='112'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='10' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.921569 0 0 0 0 0.411765 0 0 0 0 0.141176 0 0 0 0.3 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_695_49931'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_695_49931'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_bd_695_49931'
          x='32'
          y='16'
          width='82'
          height='74'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='4' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_695_49931'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='4' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_backgroundBlur_695_49931'
            result='effect2_dropShadow_695_49931'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_695_49931'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_695_49931'
          x1='56'
          y1='18'
          x2='56'
          y2='90'
          gradientUnits='userSpaceOnUse'>
          <stop stop-color='#FFD390' />
          <stop offset='1' stop-color='#EF995A' />
        </linearGradient>
      </defs>
    </svg>
  );
};
